import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

interface InputProps extends FormlyFieldProps {}

@Component({
  selector: 'app-formly-mat-currency-input',
  template: `
    <input
      matInput
      [id]="id"
      type="text"
      [readonly]="props.readonly"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [placeholder]="props.placeholder ?? ''"
      mask="separator.2"
      thousandSeparator="'"
      decimalMarker="."
    />
  `,
  styleUrls: ['./formly-mat-currency-input.component.scss'],
  imports: [MatInput, ReactiveFormsModule, FormlyModule, NgxMaskDirective],
  providers: [
    provideNgxMask({
      validation: false,
      decimalMarker: '.',
      thousandSeparator: "'",
    }),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyMatCurrencyInputComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {}
